import { Switch } from "antd";
import moment from "jalali-moment";
import React, { useState } from "react";
import ProfileImg from "../../../../assets/img/Home/profile.png";
import useFetch from "../../../../hooks/useAxios";
const AdminUserFeedBackCards = ({info}) => {
  const [instant, setinstant] = useState(false);
  const apifeedabackList = useFetch({
    method: "post",
    url: `api/admin/feedbacks/accept/${info.id}`,
    noHeader: false,
    trigger: false,
 data:{Accept:instant}
   
  });
  console.log(info.id)
  const onChange = checked => {
    setinstant(checked);
    apifeedabackList.reFetch()
  };


  return (
    <div className="AdminUserFeedBackCards">
      <div className="profle-card flex items-center gap-[10px]">
        <img src={ProfileImg} className='w-[54px] h-[54px]' />
        <div className="">
          <p className="profle-card--name">اشکان قاسمی</p>
          <p className="profle-card--date"> 0933043 7857</p>
        </div>
      </div>

    
        <div className="flex justify-between items-center my-[20px]">
          <p className="AdminUserFeedBackCards--date ">  {info.created_at}</p>

          <div className="flex gap-[8px] items-center">
            <p className="AdminUserFeedBackCards--switchlabel">نمایش در سایت</p>
            <div className="Modal_Switch">
              <Switch defaultChecked onChange={onChange} checked={instant} />
            </div>
          </div>
        </div>
        <div className="AdminUserFeedBackCards--des">
      {info.body}
        </div>
 

    </div>
  );
};

export default AdminUserFeedBackCards;
